import { render, staticRenderFns } from "./ACField.vue?vue&type=template&id=683cb688"
import script from "./ACField.vue?vue&type=script&lang=js"
export * from "./ACField.vue?vue&type=script&lang=js"
import style0 from "./ACField.vue?vue&type=style&index=0&id=683cb688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports